import React, { useState } from "react";
import { createStyles, Theme, makeStyles } from "@material-ui/core/styles";
import { Grid, Snackbar, SnackbarCloseReason, SnackbarContent } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import moment from "moment";
import style from "./style";
import * as _ from "lodash";

type props = {
  info: any;
};
const useStyles = makeStyles((theme: Theme) => createStyles(style(theme)));
export const LongTextSnackbar = (props: props): React.JSX.Element => {
  const classes = useStyles();
  const {startdate , enddate, description} = props.info;
  const [open,setOpen] = useState<boolean>(true);
  const isoUtc = moment.utc(
    startdate,
    "YYYY-MM-DD hh:mm A [(UTC)]"
  ).format("YYYY-MM-DD[T]HH:mm:ss[Z]");

  // converting to local time via userlocation
  const formatted = moment(new Date(isoUtc))
    .format("dddd, DD MMMM YYYY, hh:mm A");

  const isoUtcend = moment.utc(
    enddate,
    "YYYY-MM-DD hh:mm A [(UTC)]"
  ).format("YYYY-MM-DD[T]HH:mm:ss[Z]");

  const formattedEnddate = moment(new Date(isoUtcend))
    .format("hh:mm A");
    const formatter = new Intl.DateTimeFormat("en-US", {
        timeZoneName: "long"
    });
    const parts = formatter.formatToParts(new Date(isoUtcend));
    const tzName = parts.find(p => p.type === "timeZoneName")?.value;

  const msg = (
    <div >
      <Grid container className={classes.snackBarGrid} >
      <Grid item xs={11} xl={11} md={11} sm={11}>
        <div>
          <strong>{formatted} {"to"} {formattedEnddate}&nbsp;({tzName}):</strong>{description}
        </div>
      </Grid>
      <Grid  item xs={1} xl={1} md={1} sm={1} className={classes.snackBarGridChild}>
        <div>
          <CloseIcon onClick={()=>setOpen(false)} className={classes.closeIconSnackbar} />
        
        </div>
      </Grid>
      </Grid>
    </div>
  );


  const handleClose = (
    event: React.SyntheticEvent | Event,
    reason?: SnackbarCloseReason,
  ):any => {
    if (_.isEqual(reason,"clickaway")) {
      return;
    }
    setOpen(false);
  };

  return (
    <Snackbar
      open={open}
      autoHideDuration={30000}
      onClose={handleClose}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      transitionDuration={{ enter: 300, exit: 200 }}
      key={`${msg}+Transition`}
      message={msg}
      style={{
      width: "auto",
      maxWidth: "100%",
      marginTop: "40px",
  }}
    >
      <SnackbarContent
        message={
          msg
        }
        style={{
          backgroundColor: "#1576d6", 
          color: "#ffffff",
          fontSize: "14px",
          borderRadius: "8px",
          boxShadow: "0 8px 24px rgba(0,0,0,0.2)",
          zIndex: 99999999,
          width:"100%"
        }}

      />
    </Snackbar>

  );
};
